export default __webpack_public_path__ + "static/social media 8-4e881db36aea4548b912c670d8652964.webp";